import {createReducer, on} from '@ngrx/store';
import {
  clearDeleteManyDestinationsState,
  deleteManyDestinations,
  deleteManyDestinationsFailure,
  deleteManyDestinationsSuccess
} from './destination.delete-many.actions';
import {Destination} from '../../../services/api/destinations/destination.model';


export interface State {
  record: Destination[] | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const deleteManyDestinationsReducer = createReducer(
  initialState,

  on(deleteManyDestinations, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(deleteManyDestinationsSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteManyDestinationsFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearDeleteManyDestinationsState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

